import { createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { createRootReducer } from 'modules/index';

export const history = createBrowserHistory();

export const store = createStore(
  createRootReducer(history), // root reducer with router state
  {},
  compose(
    applyMiddleware(
      routerMiddleware(history),
      thunk
      // ... other middlewares ...
    )
  )
);


export type Dispatch = typeof store.dispatch;
export type State = ReturnType<typeof store.getState>;
